import React from 'react';

const MoneyContainer = () => {
  return (
    <div className='h-[12mm] border-[3px] text-border border-black flex items-center px-2'>
      <div className='font-bold'>금액: 일십삼만이천원 정</div>
      <div className='ml-auto font-bold'>₩132,000</div>
    </div>
  );
};

export default MoneyContainer;
